import React from "react";
import { FeatureRequest } from "interfaces/feature-request";
import { Paragraph, TabHeader } from "../shared/generic";
import { useTranslate } from "hooks/common/useTranslate/useTranslate";

const DecisionTab: React.FC<{
    featureRequest: FeatureRequest;
}> = ({ featureRequest }) => {
    const translate = useTranslate();

    return (
        <>
            <TabHeader>{translate("featureRequests.featureRequestDecision.title")}</TabHeader>
            <div>
                <Paragraph>{featureRequest.decision}</Paragraph>
            </div>
        </>
    );
};

export default DecisionTab;
